import { AxnConfigState } from "@idw-types/state/axn-config-state";
import { AxnConfigActionTypes, AxnConfigActions } from "../actions/axn-config-actions";

export const initialAxnConfigState: AxnConfigState = {
    isRefreshing: false,
    lastRefreshDate: null,
    refreshResults: null
};

export const axnConfigReducer = (
    state: AxnConfigState = initialAxnConfigState,
    action: AxnConfigActions
): AxnConfigState => {
    switch(action.type) {
        case AxnConfigActionTypes.SET_AXN_CONFIG_REFRESHING:
            return {
                ...state,
                isRefreshing: action.payload.isRefreshing
            };
        case AxnConfigActionTypes.SET_AXN_CONFIG_REFRESH_RESULTS:
            return {
                ...state,
                isRefreshing: false,
                refreshResults: action.payload.refreshResults,
                lastRefreshDate: action.payload.lastRefreshDate,
            };
        default:
            return state;
    }
};